<div *ngIf="carousel && carousel.slides" class="carousel-wrapper">
  <img
    *ngIf="carousel.background_image_web"
    class="carousel-background"
    [src]="carousel.background_image_web.data.attributes.url"
    alt="Carousel Background Image"
  />
  <div class="keen-navigation-wrapper">
    <div
      *ngIf="!isMobile && showArrows"
      class="arrow arrow-left"
      (click)="doPrev()"
    >
      <img src="/assets/icons/carousel-arrow-right.svg" alt="" />
    </div>
    <div class="keen-slider" #sliderRef>
      <div
        *ngFor="let slide of carousel!.slides; index as slideIndex"
        class="keen-slider__slide"
        [class.min-width]="isMobile"
      >
        <div
          class="carousel-slide"
          [class.active-slide]="!isMobile || slideIndex === currentSlideIndex"
          [class]="cardStyle"
        >
          <div class="slide-top">
            <img
              [attr.src]="slide.image?.data?.attributes?.url"
              [attr.alt]="slide.image?.data?.attributes?.alternativeText"
            />
            <h2 [class]="cardStyle === 'tertiary' ? 'white' : ''">
              {{ slide.heading }}
            </h2>
          </div>
          <div class="slide-bottom">
            <p>{{ slide.text }}</p>
            <div class="link-container">
              <app-cms-link
                *ngIf="slide.label"
                [linkArrow]="cardStyle !== 'tertiary'"
                [link]="slide"
                [class]="
                  'with-icon no-flex card-link ' +
                  (cardStyle === 'tertiary' ? 'white' : '')
                "
              >
                {{ slide.label }}
                <img
                  *ngIf="cardStyle === 'tertiary'"
                  class="link-arrow"
                  src="/assets/icons/white_arrow_right.svg"
                  alt="Arrow"
                />
              </app-cms-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="!isMobile && showArrows"
      class="arrow arrow-right"
      (click)="doNext()"
    >
      <img src="/assets/icons/carousel-arrow-right.svg" alt="" />
    </div>
  </div>
</div>
